import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-size-slider',
  templateUrl: './size-slider.component.html',
  styleUrl: './size-slider.component.scss',
})
export class SizeSliderComponent {
  @Input() min = 100;
  @Input() max = 500;
  @Input() value = 100;
  @Input() step = 10;
  @Output() onValueChange = new EventEmitter<number>();
  @Input() label: string = 'Size';
  @Input() sliderId: string =
    'slider_' + Math.random().toString(36).slice(2, 11);
}
